<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div class="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center">
      
      <!-- Logo -->
      <div class="flex justify-center mb-6">
        <img src="@/assets/images/kenscio-logo.png" alt="kenscio-logo" class="w-16" />
      </div>

      <!-- Title -->
      <h2 class="text-lg font-medium text-gray-800 mb-1">Forgot Password?</h2>

      <!-- Image -->
      <img src="@/assets/images/forgot_passowrd.png" alt="Reset Illustration" class="w-28 mx-auto mb-4" />

      <!-- Subtext -->
      <p class="text-sm text-gray-600 mb-6">
        Enter the new password you'd like to use for your account.
      </p>

      <!-- Form -->
      <el-form
        ref="resetPasswordForm"
        :model="resetPasswordForm"
        :rules="resetPasswordFormRules"
        label-position="top"
        class="text-left space-y-4">
        
        <el-form-item label="New Password" prop="newPassword">
          <el-input
            v-model="resetPasswordForm.newPassword"
            type="password"
            placeholder="Enter New Password"
            autocomplete="new-password"
            clearable />
        </el-form-item>

        <el-form-item label="Confirm Password" prop="confirmPassword">
          <el-input
            v-model="resetPasswordForm.confirmPassword"
            type="password"
            placeholder="Confirm New Password"
            autocomplete="new-password"
            clearable />
        </el-form-item>
      </el-form>

      <!-- Button -->
      <button
        @click="createNewPassword"
        class="w-full mt-4 py-3 rounded-md bg-[#0c5c6d] text-white font-semibold hover:bg-[#094752] transition duration-150"
        :disabled="resettingPassword">
        Set New Password
      </button>

      <!-- Login Redirect -->
      <p class="mt-6 text-sm text-gray-600">
        Remember your password?
        <el-button
          type="text"
          class="text-[#0c5c6d] font-medium hover:underline"
          @click="$router.push({ name: 'login-page' })">
          Login
        </el-button>
      </p>
    </div>
  </div>
</template>

<script>
import forgotPassword from './forgotPassword.js';
export default forgotPassword;
</script>

<style lang="scss" src="./forgotPassword.scss"></style>
